import { useContext } from 'react';
import MainCard from '../../../../components/MainCard/Index';
import ComponentSpecialCondition from './componentSpecialCondition';
import { ContextAuth } from '../../../../contexts/Authentication';
import SpecialConditionUpdateMobilePage from './mobile';

const SpecialCondition: React.FC = () => {
  const { isMobile } = useContext(ContextAuth);

  if (isMobile) return <SpecialConditionUpdateMobilePage />;

  return (
    <MainCard title="ÁREA DO CANDIDATO - " subtitle="CONDIÇÕES ESPECIAIS PARA PROVA">
      <ComponentSpecialCondition />
    </MainCard>
  );
};

export default SpecialCondition;
